import React from 'react';
import { DateRange } from '@schuettflix/react-components';
import { SectionSummaryContent, SectionSummaryContentItem } from '@/shared/components/SectionSummary.tsx';
import { useTranslation } from 'react-i18next';
import { usePositionContext } from '@/shared/context/PositionContext';

export function PositionSettingsSectionSummary() {
    const { t, i18n } = useTranslation();
    const { contextData } = usePositionContext();
    const { validFrom, validTo, active } = contextData.getFormData();

    if (!validFrom || !validTo) {
        return null;
    }

    const sectionSummaryContentList: SectionSummaryContentItem[] = [
        {
            label: t('position.sections.positionSettings.datePicker.label'),
            value: <DateRange dateFrom={validFrom} dateTo={validTo} locale={i18n.language} />,
        },
        {
            label: t('position.settings.state.label'),
            value: active ? t(`position.settings.state.active`) : t(`position.settings.state.inactive`),
        },
    ];

    return <SectionSummaryContent sectionSummaryContentList={sectionSummaryContentList} />;
}
